module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "teach-items"
  }, [_c('h2', [_vm._v("评委采访")]), _vm._v(" "), _c('div', {
    staticClass: "item-tech"
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: " vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptionsLi
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-tech"
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptionsXia
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-tech"
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptionsZhu
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item-tech"
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptionsHu
    },
    on: {
      "play": function($event) {
        return _vm.onPlayerPlay($event)
      },
      "pause": function($event) {
        return _vm.onPlayerPause($event)
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-636e337b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Award.vue
// module id = 622
// module chunks = 1